export enum AlertType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  NOTIFICATION = 'NOTIFICATION',
  SUCCESS = 'SUCCESS',
}
